import React from "react";
import "./projects.css";

import procGen from "../assets/images/ProcGen.gif";
import mazeGen from "../assets/images/MazeGen.gif";
import website from "../assets/images/Website.png";

function Projects() {
  return (
    <section className="projects-section">
      <div className="projects-container">
        <h2 className="projects-title">Projects</h2>

        <div className="projects-grid">
          {/* Project 1 */}
          <div className="project-item">
            <img
              src={website}
              alt="Website Screenshot"
              className="project-image"
            />
            <h3 className="project-title">Portfolio Website</h3>
            <p className="project-description">
              This is the website you are on right now. It not only is a means to show my portfolio and skills, but also a learning opputunity for me to get into react.
            </p>
            <p className="project-tech">
              <strong>Technologies:</strong> HTML, CSS, JavaScript, and the react framework
            </p>
            <p className="project-role">
              <strong>Role & Contributions:</strong> Sole Creator and Designer
            </p>
            <p className="project-challenges">
              <strong>Challenges & Solutions:</strong> Before this project, I had never worked in react so this was a challenge. However, after a learning curve, I feel much more comfortable.
            </p>
          </div>

          {/* Project 2 */}
          <div className="project-item">
            <img
              src={procGen}
              alt="ProcGen Screenshot"
              className="project-image"
            />
            <h3 className="project-title">Procedual Terrain Generation</h3>
            <p className="project-description">Built in Unity, this is a means to generate infinite procedual terrain, for use in games.</p>
            <p className="project-tech"><strong>Technologies:</strong> Noise, Multi-threading, LOD</p>
            <p className="project-role"><strong>Role & Contributions:</strong> Sole Creator and Designer</p>
            <p className="project-challenges"><strong>Challenges & Solutions:</strong> Multi-threading is hard to work with, but nessesary with a project like this. It was a challenge to solve, but the results were oh so worth it</p>
          </div>

          {/* Project 3 */}
          <div className="project-item">
            <img
              src={mazeGen}
              alt="mazeGen Screenshot"
              className="project-image"
            />
            <h3 className="project-title">Random Maze Generation</h3>
            <p className="project-description">Built in Unity, this uses depth-first search pathfinding to generate mazes.</p>
            <p className="project-tech"><strong>Technologies:</strong> Pathfinding</p>
            <p className="project-role"><strong>Role & Contributions:</strong> Sole Creator and Designer</p>
            <p className="project-challenges"><strong>Challenges & Solutions:</strong> I had always used predefined path finding alorithms like A*, so it was a unique and exciting experience to create one myself</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Projects;